import {Directive, HostListener, Input} from '@angular/core';
import {AnalyticsService} from "./analytics.service";

@Directive({
  selector: '[analyticsEvent]'
})
export class AnalyticsEventDirective {

  @Input() analyticsEvent: string;
  @Input() analyticsProperties: any;

  constructor(private Analytics: AnalyticsService) {
  }

  @HostListener('click')
  onClick() {
    this.Analytics.trackEvent(this.analyticsEvent, {category: 'Action', ...(this.analyticsProperties || {})});
  }
}
